import api from '@pray/shared/utils/api';

export async function updateArtistMasterToggle({ artistId, leadCampaignId }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!leadCampaignId) throw Error('Campaign ID is required');
  const url = `/web/studio/artists/${artistId}/lead-campaigns/${leadCampaignId}/master-toggle`;
  const response = await api.executePutRequest(url, {});
  return response.data;
}
